import { Tooltip } from '@shared/components/Tooltip';
import type { TabToggleProps } from './types';

function TabToggle<T extends string>({
  tabs,
  activeTab,
  onChange,
  ariaLabel,
  className = '',
  fitContent = false,
}: TabToggleProps<T>) {
  const containerClass = fitContent
    ? 'inline-flex bg-[#ECEDF0] rounded-xl p-1 gap-1 max-w-full h-[48px]'
    : 'flex bg-[#ECEDF0] rounded-xl p-1 gap-1 w-full max-w-[432px] h-[48px]';
  const wrapperClass = fitContent ? '' : 'flex-1';
  const tabSizeClass = fitContent ? 'px-[21px]' : 'w-full';
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={`${containerClass} ${className}`}
    >
      {tabs.map((tab) => {
        const button = (
          <button
            role="tab"
            type="button"
            data-testid={`tab-${tab.id}`}
            aria-selected={activeTab === tab.id}
            disabled={tab.disabled}
            onClick={() => !tab.disabled && onChange(tab.id)}
            className={`${tabSizeClass} h-[40px] rounded-md text-titleMedium font-semibold whitespace-nowrap transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2A4455] ${
              tab.disabled
                ? 'opacity-38 cursor-not-allowed text-[#474A4C]'
                : activeTab === tab.id
                  ? 'bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.15),0px_2px_6px_2px_rgba(0,0,0,0.08)] text-[#2A4455] cursor-pointer'
                  : 'text-[#878b8e] hover:text-[#2A4455] cursor-pointer'
            }`}
          >
            {tab.label}
          </button>
        );

        return (
          <div key={tab.id} className={wrapperClass}>
            {tab.disabled && tab.disabledTooltip ? (
              <Tooltip
                content={tab.disabledTooltip}
                side="bottom"
                cursor="not-allowed"
                triggerTabIndex={-1}
              >
                {button}
              </Tooltip>
            ) : (
              button
            )}
          </div>
        );
      })}
    </div>
  );
}

export default TabToggle;
